module.exports = __webpack_public_path__ + "static/media/apple-icon-120x120.c8ee763b.png";